'use es6';

import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ADD_FOLDER_FAILED, DELETE_FOLDER_FAILED, MOVE_FOLDER_ATTEMPTED, MOVE_FOLDER_SUCCEEDED, MOVE_FOLDER_FAILED, RENAME_FOLDER_SUCCEEDED, RENAME_FOLDER_FAILED, RENAME_FOLDER_ATTEMPTED } from 'FileManagerCore/actions/ActionTypes';
import * as Actions from 'FileManagerCore/actions/Folders';
import { getFoldersById } from 'FileManagerCore/selectors/Folders';
import { rename, remove, move } from 'FileManagerCore/api/Folders';
import { fetchFoldersByParentId, fetchFolderByIdWithBreadcrumbs } from 'FileManagerCore/actions/FolderFetch';
import { reportError } from 'FileManagerCore/utils/logging';
import { NAVIGATE_TO_FOLDER } from './ActionTypes';
import { closeModal } from './Actions';
import { addFolderBulkSelection } from './Bulk';
import UsageTracker from '../utils/usageTracker';
import { selectIsUngatedForBackendPoweredPagination } from 'FileManagerCore/selectors/Auth';
import { jsx as _jsx } from "react/jsx-runtime";
export function removeFolder(folder) {
  return dispatch => {
    UsageTracker.track('fileManagerManageFolders', {
      action: 'delete'
    });
    remove(folder.get('id')).then(() => dispatch(Actions.receiveFolderDelete(folder)), error => {
      const keyBase = `FileManagerDashboard.notifications.deleteFolder.error`;
      dispatch({
        type: DELETE_FOLDER_FAILED,
        meta: {
          notification: {
            type: 'danger',
            titleText: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `${keyBase}.title`
            }),
            message: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `${keyBase}.message`,
              options: {
                folder: folder.get('name')
              }
            })
          }
        },
        folder,
        error
      });
    }).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  };
}
export const navigateToFolder = folderId => (dispatch, getState) => {
  const isUngatedForBackendPoweredPagination = selectIsUngatedForBackendPoweredPagination(getState());

  // If ungated, all folder navigation will fetch needed folder data after detecting query param changes
  // See Dashboard.js for this logic
  if (!isUngatedForBackendPoweredPagination) {
    dispatch(fetchFoldersByParentId(folderId));
    const foldersById = getFoldersById(getState());
    const folder = foldersById.get(folderId);
    if (folderId && !folder) {
      dispatch(fetchFolderByIdWithBreadcrumbs(folderId));
    }
  }
  dispatch({
    type: NAVIGATE_TO_FOLDER,
    folderId
  });
};
export function receiveRenameFolder(folder) {
  return {
    type: RENAME_FOLDER_SUCCEEDED,
    folder
  };
}
export function renameFolder(folder, newName) {
  return dispatch => {
    UsageTracker.track('fileManagerManageFolders', {
      action: 'rename'
    });
    dispatch({
      type: RENAME_FOLDER_ATTEMPTED
    });
    rename(folder.get('id'), newName).then(data => {
      dispatch(receiveRenameFolder(data));
      dispatch(closeModal());
    }).catch(error => {
      reportError(error, {
        type: RENAME_FOLDER_FAILED
      });
      dispatch({
        type: RENAME_FOLDER_FAILED,
        meta: {
          notification: {
            type: 'danger',
            titleText: I18n.text('FileManagerDashboard.notifications.renameFolder.error.title'),
            message: I18n.text('FileManagerDashboard.notifications.renameFolder.error.message', {
              folder: folder.get('name')
            })
          }
        },
        folder,
        error
      });
    });
  };
}
export function moveFolder(folder, destination) {
  return dispatch => {
    UsageTracker.track('fileManagerManageFolders', {
      action: 'move'
    });
    dispatch({
      type: MOVE_FOLDER_ATTEMPTED
    });
    move(folder.get('id'), destination).then(data => {
      dispatch({
        type: MOVE_FOLDER_SUCCEEDED,
        folder: data
      });
    }, error => {
      dispatch({
        type: MOVE_FOLDER_FAILED,
        meta: {
          notification: {
            type: 'danger',
            titleText: I18n.text('FileManagerDashboard.notifications.moveFolder.error.title'),
            message: I18n.text('FileManagerDashboard.notifications.moveFolder.error.message', {
              folder: folder.get('name')
            })
          }
        },
        error,
        folder
      });
    }).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  };
}
export function addFolder({
  parentId,
  name
}) {
  return dispatch => {
    UsageTracker.track('fileManagerManageFolders', {
      action: 'create-new-folder'
    });
    dispatch(Actions.addFolder({
      parentId,
      name
    })).then(result => {
      if (result && result.status && result.status === 403) {
        setTimeout(() => window.location.reload(), 2000);
      } else {
        dispatch(addFolderBulkSelection([result.get('id')]));
      }
    }).catch(err => {
      reportError(err, {
        type: ADD_FOLDER_FAILED
      });
    });
  };
}